import { hmsAPI } from '@/api'

export const getRaces = params => hmsAPI.get('/races', { params })
export const getRace = raceId => hmsAPI.get(`/races/${raceId}`)
export const updateRace = (raceId, data) => hmsAPI.put(`/races/${raceId}`, data)
